import { P2GText } from '@parcel2go/core-ui';
import { P2GAlert } from '@parcel2go/core-ui';

export const FilterDialog = () => {
  return (
    <P2GAlert color="info" id="quote-filter-dialog">
      <P2GText variant="body2">
        Choose to show or hide the services you use the most. Once customised, don't forget to <u>click save</u>.
      </P2GText>
    </P2GAlert>
  );
};
